import { parse, format, isValid, parseISO } from 'date-fns'
const default_format = 'dd/MM/yyyy'

const date = {
    isValid: (date) => isValid(date),
    format: (initial_date, date_format, options = null) => {
        let date = initial_date
        if (date === 'now') {
            date = +new Date()
        }
        if (date) {
            if (!date_format) {
                date_format = default_format
            } else {
                if (date_format === 'full' || date_format === 'timestamp') date_format = 'dd/MM/yyyy HH:mm:ss'
                if (date_format === 'time') date_format = 'HH:mm:ss'
            }
            const is_time_format =
                date_format === 'full' ||
                date_format === 'timestamp' ||
                date_format === 'time' ||
                !!~date_format.indexOf('H') ||
                !!~date_format.indexOf('m') ||
                !!~date_format.indexOf('s')
            date = (!is_time_format && date.length > 10 && date.substring(0, 10)) || date
            date = (typeof date === 'string' && parseISO(date)) || date
            const is_date_valid = isValid(date)
            !is_date_valid && console.error('Invalid date', { date: initial_date }, { date_format }, { options })
            return (is_date_valid && format(date, date_format, options)) || null
        }
    },
    parse: (date_string, options = null) => {
        return parse(date_string, options)
    },
}

export default date
